import { Spin, Tabs, message } from "antd";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import "./HomeSettingPage.css";
import {
  apiGetActivityList,
  apiGetRegistrationSettings,
} from "services/dashboardService";
import GeneralTab from "./GeneralTab";
import RegistrationTab from "./RegistrationTab";
import ExtraTab from "./ExtraTab";
import WaiverTab from "./WaiverTab";
import Step1FormTab from "./Step1FormTab";
import CheckoutTab from "./CheckoutTab";
function HomeSettingPage(props) {
  const { TabPane } = Tabs;
  const { id } = useParams();
  const userDataStore = useSelector((x) => x.userDataStore);

  const [activityList, setActivityList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [registrationID, setRegistrationID] = useState("");
  const [isBusy, setIsBusy] = useState(false);
  const [settingInfo, setSettingInfo] = useState(undefined);

  useEffect(() => {
    getActivityList();
    if (id != undefined) {
      setRegistrationID(id);
      getSettingInfo(id);
    }
  }, [id]);

  const getActivityList = async () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    apiGetActivityList()
      .then((res) => {
        if (res != undefined) {
          setActivityList(res);
        } else {
          setActivityList([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getSettingInfo = async (regID) => {
    setIsBusy(true);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", regID);
    apiGetRegistrationSettings(params)
      .then((res) => {
        setIsBusy(false);
        setSettingInfo(res);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onChange = (key) => { };
  const items = [
    {
      key: "1",
      label: "General Setup",
      children: (
        <GeneralTab
          activityList={activityList}
          registrationID={registrationID}
          setRegistrationID={setRegistrationID}
          settingInfo={settingInfo}
        />
      ),
    },
    {
      key: "2",
      label: "Step 1 Form",
      disabled: !registrationID,
      children: (
        <Step1FormTab
          registrationID={registrationID}
          setRegistrationID={setRegistrationID}
          settingInfo={settingInfo}
        />
      ),
    },
    {
      key: "3",
      label: "Registration",
      disabled: !registrationID,
      children: (
        <RegistrationTab
          registrationID={registrationID}
          setRegistrationID={setRegistrationID}
          settingInfo={settingInfo}
        />
      ),
    },
    {
      key: "4",
      label: "Extra Programs",
      disabled: !registrationID,
      children: (
        <ExtraTab
          groupList={groupList}
          setGroupList={setGroupList}
          registrationID={registrationID}
          setRegistrationID={setRegistrationID}
          settingInfo={settingInfo}
        />
      ),
    },
    {
      key: "5",
      label: "Waivers",
      disabled: !registrationID,
      children: (
        <WaiverTab
          registrationID={registrationID}
          setRegistrationID={setRegistrationID}
          settingInfo={settingInfo}
        />
      ),
    },
    {
      key: "6",
      label: "Checkout",
      disabled: !registrationID,
      children: (
        <CheckoutTab
          registrationID={registrationID}
          settingInfo={settingInfo}
        />
      ),
    },
  ];
  return (
    <CommonDivWidget>
      <div style={{ minHeight: "80vh" }}>
        <Spin spinning={isBusy}>
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChange}
            className="home-setting"
          />
        </Spin>
      </div>
    </CommonDivWidget>
  );
}

export default HomeSettingPage;
